import { render, staticRenderFns } from "./ui-icon.vue?vue&type=template&id=3e25c4c9&"
import script from "./ui-icon.vue?vue&type=script&lang=ts&"
export * from "./ui-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports